export default __webpack_public_path__ + "static/media/02.b4d4daa7.svg";